import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Toaster } from "sonner";

const ThemedToaster = () => {
  const isLight = () => document.documentElement.classList.contains("theme-light");
  const [light, setLight] = useState(isLight);
  useEffect(() => {
    const obs = new MutationObserver(() => setLight(isLight()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  return <Toaster position="bottom-right" theme={light ? "light" : "dark"} richColors />;
};
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import DataRoom from "@/pages/DataRoom";
import Admin from "@/pages/Admin";

const InvestorRoute = ({ children }) => {
  const { investor } = useAuth();
  return investor ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ThemedToaster />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/dataroom" element={<InvestorRoute><DataRoom /></InvestorRoute>} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
